import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { DocumentService } from '../../../../document/shared/services/document.service';
import { AgrementsClientService } from '../../../../identite/shared/services/agrements-client.service';
import { TRANSLATE } from '../../../classes/translatable';
import { AlertService } from '../../../services/alert.service';
import {Document} from '../../../../document/shared/classes/document';

@Component({
  selector: 'app-document-input',
  templateUrl: './document-input.component.html',
  styleUrls: ['./document-input.component.css']
})
export class DocumentInputComponent implements OnInit {
  @Input()  resourceId: string;
  @Input()  resource: string;
  @Input()  resourceName: string;
  @Input()  value: string;
  @Input()  label: string;
  @Input()  classeurId = "305";

  @Output() valueChanged: EventEmitter<string> = new EventEmitter();

  @ViewChild('fileInput') fileInput: ElementRef;

  documents: Document[] = [];
  constructor(
      private agrementsClientService: AgrementsClientService,
      private alertService: AlertService,
      private documentService: DocumentService,
  ) { }

  ngOnInit() {
      this.fetchDocument();
  }

  fetchDocument() {
    let documentIds = [];
    if (this.value != null){
       documentIds = this.value.split(',');


        documentIds.forEach(docId=>{
          if (docId !== 'undefined'){
            this.documentService.getDocumentById(docId, this.resource, this.resourceId).subscribe(response => {
              if (response.status === 200) {
                const document = new Document();
                document.name = response.data.name;
                document.file_name = response.data.file_name;
                document.id =  response.data.id;
                this.documents = [...this.documents, document];
              }
            });
          }
        });
    }
      
  }

  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  uploadFile(files: FileList) {
    if (files.length <= 0)
      return;
    this.documentService.uploadDocument(files[0], this.resource, this.resourceId, this.classeurId, "").subscribe(response => {
      if (response.status === 200) {
        const document = new Document();
        document.name = files[0].name;
        document.file_name = response.data.file_name;
        document.id =  response.data.id;
        this.documents = [...this.documents, document];
        
        this.valueChange();
      } else {
        this.alertService.warn(TRANSLATE(response.message));
      }
    });
  }

  onDeleteDocument(document: Document) {
    if (this.resourceId !== null) {
      this.documentService.deleteDocument(document.id).subscribe(response => {
        if (response.status === 200) {
          const documents = [];
          this.documents.forEach(elem => {
            if (elem.id !== document.id)
              documents.push(elem);
          });
          this.documents = documents;
          this.valueChange();
          
        } else {
          this.alertService.warn(TRANSLATE('Une erreur est survenue'));
        }
      });
    }
  }

  valueChange(){
    let docId: string = '';


      this.documents.forEach(doc =>{
        if(doc.id != 'undefined'){
          if(docId == ''){
            docId = doc.id;
          } else {
            docId = docId +","+doc.id;
          }
        }
      });
    this.valueChanged.emit(docId);
  }
}
